/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'xs', 'sm', 'md' ] },
      tokens: {
        titleHeadingFontName: 'HNforTELUSSA',
        titleHeadingFontSize: 24,
        titleHeadingFontWeight: '400',
        titleHeadingLineHeight: 1.33333333333
      }
    }
  ],
  tokens: {
    backgroundGradient: {
      angle: 135,
      stops: [
        { color: '#4b286d', hint: 0.75, stop: 0 },
        { color: '#e53293', stop: 1 }
      ],
      type: 'linear'
    },
    color: '#414547',
    linkFontName: 'HNforTELUSSA',
    linkFontSize: 16,
    linkFontWeight: '700',
    linkLineHeight: 1.5,
    marginBottom: 16,
    paddingBottom: 16,
    paddingLeft: 32,
    paddingRight: 32,
    paddingTop: 16,
    titleFontName: 'HNforTELUSSA',
    titleFontSize: 20,
    titleFontWeight: '400',
    titleHeadingFontName: 'HNforTELUSSA',
    titleHeadingFontSize: 28,
    titleHeadingFontWeight: '400',
    titleHeadingLineHeight: 1.28571428571,
    titleLineHeight: 1.6,
    width: 2
  }
}
export default theme
